import { FC, useEffect } from 'react';

const ConditionOrder: FC = () => {
  useEffect(() => {
    window.location.href =
      'https://www.settrade.com/th/services-and-tools/trading-program/add-on/conditional-order/introduction';
  }, []);

  return <div></div>;
};

export default ConditionOrder;
